/* PHAT Bars custom behaviour */
(() => {
  /* Pop-ups used by the product "Installation & fitting" block */
  document.addEventListener('click', (evt) => {
    const opener = evt.target.closest('[data-phat-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.phatDialog);
      if (dialog && typeof dialog.showModal === 'function') {
        evt.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (evt.target.closest('[data-phat-dialog-close]')) {
      evt.target.closest('dialog')?.close();
      return;
    }

    // Close when clicking the backdrop
    if (evt.target instanceof HTMLDialogElement && evt.target.classList.contains('phat-dialog')) {
      evt.target.close();
    }
  });

  /* Mega menu side list: show the hovered/focused category's panel */
  const activateRailItem = (item) => {
    const rail = item.closest('[data-phat-rail]');
    if (!rail || item.classList.contains('is-active')) return;
    rail.querySelectorAll('.phat-rail__item.is-active').forEach((el) => el.classList.remove('is-active'));
    item.classList.add('is-active');
  };
  document.addEventListener('mouseover', (evt) => {
    const item = evt.target.closest?.('.phat-rail__item');
    if (item) activateRailItem(item);
  });
  document.addEventListener('focusin', (evt) => {
    const item = evt.target.closest?.('.phat-rail__item');
    if (item) activateRailItem(item);
  });

  /* Hero vehicle finder: make -> model -> collection */
  const initFinder = (form) => {
    if (form.dataset.phatFinderReady) return;
    form.dataset.phatFinderReady = 'true';
    const makeSelect = form.querySelector('[data-phat-finder-make]');
    const modelSelect = form.querySelector('[data-phat-finder-model]');
    const modelPlaceholder = modelSelect.options[0].textContent;

    makeSelect.addEventListener('change', () => {
      const option = makeSelect.selectedOptions[0];
      const models = (option?.dataset.models || '').split('||').filter(Boolean);
      modelSelect.innerHTML = '';
      modelSelect.add(new Option(models.length ? modelPlaceholder : `All ${option.textContent.trim()} parts`, ''));
      models.forEach((entry) => {
        const [title, url] = entry.split('::');
        modelSelect.add(new Option(title, url));
      });
      modelSelect.disabled = !makeSelect.value || models.length === 0;
    });

    form.addEventListener('submit', (evt) => {
      evt.preventDefault();
      const url = modelSelect.value || makeSelect.value;
      if (url) window.location.href = url;
    });
  };
  /* Hero product hotspots: place dots relative to the cropped (object-fit: cover) image */
  const placeHotspots = (layer) => {
    const hero = layer.closest('.phat-hero');
    const media = hero && hero.querySelector('.phat-hero__media');
    if (!media) return;
    const ratio = parseFloat(layer.dataset.imageRatio) || 1.5;
    const posX = { left: 0, center: 0.5, right: 1 }[layer.dataset.imagePosition] ?? 0.5;
    const heroRect = hero.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    const cw = mediaRect.width;
    const ch = mediaRect.height;
    let dw = cw;
    let dh = cw / ratio;
    if (dh < ch) {
      dh = ch;
      dw = ch * ratio;
    }
    const offX = (cw - dw) * posX + (mediaRect.left - heroRect.left);
    const offY = (ch - dh) * 0.5 + (mediaRect.top - heroRect.top);
    const blockers = [...hero.querySelectorAll('.phat-hero__copy, .phat-hero__dock-inner')].map((el) => {
      const r = el.getBoundingClientRect();
      return { l: r.left - heroRect.left - 24, r: r.right - heroRect.left + 24, t: r.top - heroRect.top - 24, b: r.bottom - heroRect.top + 24 };
    });
    layer.querySelectorAll('.phat-hotspot').forEach((spot) => {
      const x = offX + (parseFloat(spot.dataset.x) / 100) * dw;
      const y = offY + (parseFloat(spot.dataset.y) / 100) * dh;
      const inView = x > 20 && x < heroRect.width - 20 && y > 20 && y < heroRect.height - 20;
      const blocked = blockers.some((b) => x > b.l && x < b.r && y > b.t && y < b.b);
      spot.style.left = `${x}px`;
      spot.style.top = `${y}px`;
      spot.classList.toggle('is-placed', inView && !blocked);
      spot.classList.toggle('phat-hotspot--flip-x', x > heroRect.width - 320);
      spot.classList.toggle('phat-hotspot--flip-y', y > heroRect.height * 0.55);
    });
  };
  const closeHotspots = (except) => {
    document.querySelectorAll('.phat-hotspot.is-open').forEach((spot) => {
      if (spot === except) return;
      spot.classList.remove('is-open');
      spot.querySelector('.phat-hotspot__dot')?.setAttribute('aria-expanded', 'false');
    });
  };
  const initHotspots = () => {
    document.querySelectorAll('[data-phat-hotspots]').forEach((layer) => {
      placeHotspots(layer);
      if (layer.dataset.phatHotspotsReady) return;
      layer.dataset.phatHotspotsReady = 'true';
      layer.querySelectorAll('.phat-hotspot').forEach((spot) => {
        const dot = spot.querySelector('.phat-hotspot__dot');
        const open = () => {
          closeHotspots(spot);
          spot.classList.add('is-open');
          dot.setAttribute('aria-expanded', 'true');
        };
        spot.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) open(); });
        spot.addEventListener('mouseleave', () => { if (window.matchMedia('(hover: hover)').matches) closeHotspots(); });
        dot.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (spot.classList.contains('is-open')) closeHotspots(); else open();
        });
      });
    });
  };
  document.addEventListener('click', (evt) => {
    if (!evt.target.closest('.phat-hotspot')) closeHotspots();
  });
  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape') closeHotspots();
  });
  let hotspotResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(hotspotResizeTimer);
    hotspotResizeTimer = setTimeout(initHotspots, 120);
  });
  window.addEventListener('load', initHotspots);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initHotspots);
  initHotspots();
  document.addEventListener('shopify:section:load', initHotspots);

  /* Range / make tiles on touch screens: open the list in a bottom sheet */
  let phatSheet;
  const getSheet = () => {
    if (phatSheet) return phatSheet;
    phatSheet = document.createElement('dialog');
    phatSheet.className = 'phat-sheet';
    phatSheet.innerHTML = '<div class="phat-sheet__head"><p class="phat-sheet__title"></p><button type="button" class="phat-sheet__close" aria-label="Close">&times;</button></div><ul class="phat-sheet__list"></ul><a class="phat-sheet__all"></a>';
    phatSheet.querySelector('.phat-sheet__close').addEventListener('click', () => phatSheet.close());
    phatSheet.addEventListener('click', (evt) => { if (evt.target === phatSheet) phatSheet.close(); });
    document.body.appendChild(phatSheet);
    return phatSheet;
  };
  document.addEventListener('click', (evt) => {
    const toggle = evt.target.closest('.phat-range-vehicles__toggle');
    if (!toggle) return;
    evt.preventDefault();
    const wrap = toggle.closest('[data-phat-range-vehicles]');
    const sheet = getSheet();
    sheet.querySelector('.phat-sheet__title').textContent = wrap.querySelector('.phat-range-vehicles__title').textContent;
    sheet.querySelector('.phat-sheet__list').innerHTML = wrap.querySelector('.phat-range-vehicles__list').innerHTML;
    const all = wrap.querySelector('.phat-range-vehicles__all');
    const sheetAll = sheet.querySelector('.phat-sheet__all');
    sheetAll.href = all.getAttribute('href');
    sheetAll.textContent = all.textContent;
    if (typeof sheet.showModal === 'function') sheet.showModal();
    else window.location.href = all.getAttribute('href');
  });

  /* Range tiles: drop vehicles that have no published products in the category.
     The Liquid list uses collection.all_types, which also counts unpublished products. */
  const verifyRangeVehicles = async () => {
    const wraps = [...document.querySelectorAll('[data-phat-range-vehicles]:not([data-verified])')];
    if (!wraps.length) return;
    const handles = [...new Set(wraps.flatMap((w) => [...w.querySelectorAll('li[data-model]')].map((li) => li.dataset.model)))];
    const typesByModel = {};
    await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(`/collections/${handle}/products.json?limit=250`);
        const data = await res.json();
        typesByModel[handle] = new Set((data.products || []).map((p) => p.product_type));
      } catch (e) {
        typesByModel[handle] = null; // unknown: keep the link
      }
    }));
    wraps.forEach((wrap) => {
      wrap.querySelectorAll('li[data-model]').forEach((li) => {
        const available = typesByModel[li.dataset.model];
        if (!available) return;
        const types = li.dataset.types ? li.dataset.types.split('|') : [];
        const hasProducts = types.length ? types.some((t) => available.has(t)) : available.size > 0;
        if (!hasProducts) li.remove();
      });
      wrap.dataset.verified = 'true';
      if (!wrap.querySelector('li[data-model]')) wrap.remove();
    });
  };
  const scheduleRangeCheck = () => {
    if (!document.querySelector('[data-phat-range-vehicles]')) return;
    if ('requestIdleCallback' in window) window.requestIdleCallback(verifyRangeVehicles, { timeout: 2000 });
    else setTimeout(verifyRangeVehicles, 600);
  };
  scheduleRangeCheck();
  document.addEventListener('shopify:section:load', scheduleRangeCheck);

  const initFinders = () => document.querySelectorAll('[data-phat-finder]').forEach(initFinder);
  initFinders();
  document.addEventListener('shopify:section:load', initFinders);
})();

/* Hero: reveal the copy as the page scrolls */
(() => {
  const heroes = [...document.querySelectorAll('[data-phat-hero-reveal]')];
  if (!heroes.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let ticking = false;
  const update = () => {
    ticking = false;
    heroes.forEach((hero) => {
      const wrapper = hero.parentElement;
      const top = wrapper.getBoundingClientRect().top + window.scrollY;
      const start = Math.max(0, top - window.innerHeight * 0.5);
      let distance = Math.max(160, Math.min(320, window.innerHeight * 0.32));
      const content = hero.querySelector('.phat-hero__content');
      const copy = hero.querySelector('.phat-hero__copy');
      if (content && copy) {
        // Finish while the heading is still below the sticky header
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height')) || 0;
        const copyTop = hero.getBoundingClientRect().top + window.scrollY + content.offsetTop + copy.offsetTop;
        distance = Math.max(100, Math.min(distance, copyTop - headerHeight - 24 - start));
      }
      if (getComputedStyle(hero).position === 'sticky') {
        // Pinned on desktop: finish the reveal a little before the hero starts scrolling away
        const stickyTop = parseFloat(getComputedStyle(hero).top) || 0;
        distance = Math.max(160, (top - stickyTop + wrapper.offsetHeight - hero.offsetHeight - start) * 0.75);
      }
      const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
      const eased = 1 - Math.pow(1 - progress, 3);
      hero.style.setProperty('--reveal', eased.toFixed(3));
      hero.classList.toggle('is-revealed', eased > 0.6);
    });
  };
  const queue = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };
  heroes.forEach((hero) => hero.classList.add('is-reveal-ready'));
  update();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
})();

/* Hero: fill the space left below the header so the vehicle finder is always in the first view */
(() => {
  const heroes = [...document.querySelectorAll('.phat-hero')];
  if (!heroes.length) return;
  let lastWidth = 0;
  const size = (force) => {
    if (!force && window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    heroes.forEach((hero) => {
      const top = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty('--phat-hero-avail', `${Math.round(window.innerHeight - top)}px`);
      const dock = hero.querySelector('.phat-hero__dock');
      if (dock) hero.style.setProperty('--phat-dock-h', `${dock.offsetHeight}px`);
      const copy = hero.querySelector('.phat-hero__copy');
      if (copy) hero.style.setProperty('--phat-copy-h', `${copy.offsetHeight}px`);
    });
    window.dispatchEvent(new Event('scroll'));
  };
  size(true);
  window.addEventListener('load', () => size(true));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => size(true));
  setTimeout(() => size(true), 1200);
  window.addEventListener('resize', () => size(false));
})();

/* Footer selling points: continuous ticker on phones */
(() => {
  document.querySelectorAll('.phat-footer__usps').forEach((list) => {
    if (list.dataset.phatMarquee) return;
    list.dataset.phatMarquee = 'true';
    const wrap = document.createElement('div');
    wrap.className = 'phat-footer__marquee';
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);
    [...list.children].forEach((item) => {
      const clone = item.cloneNode(true);
      clone.classList.add('phat-footer__usp--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      list.appendChild(clone);
    });
  });
})();

/* Phones: account icon on the left, menu button on the far right after the cart */
(() => {
  const left = document.querySelector('#pageheader .logo-area__left__inner');
  const right = document.querySelector('#pageheader .logo-area__right__inner');
  const toggle = left && left.querySelector('.mobile-nav-toggle');
  const account = right && right.querySelector('.header-account-link');
  const cart = right && right.querySelector('.cart-link');
  if (!left || !right || !toggle || !account || !cart) return;
  const mq = window.matchMedia('(max-width: 767.98px)');
  const place = () => {
    if (mq.matches) {
      left.prepend(account);
      right.append(toggle);
    } else {
      left.prepend(toggle);
      right.insertBefore(account, cart);
    }
  };
  place();
  mq.addEventListener('change', place);
})();
